import InsuranceModal from 'InsuranceModal.svelte';

const insuranceModalOptions = {
    styleWindow: {
        borderRadius: '25px',
    },
    styleContent: {
        padding: 0,
    },
    closeButton: false,
    closeOnEsc: true,
    closeOnOuterClick: true,
};

export { insuranceModalOptions, InsuranceModal };
